import { render, staticRenderFns } from "./GuidedTourWaypoint.vue?vue&type=template&id=3981e1e8&scoped=true&"
import script from "./GuidedTourWaypoint.vue?vue&type=script&lang=js&"
export * from "./GuidedTourWaypoint.vue?vue&type=script&lang=js&"
import style0 from "./GuidedTourWaypoint.vue?vue&type=style&index=0&id=3981e1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3981e1e8",
  null
  
)

export default component.exports